/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import TextField from 'material-ui/TextField/TextField';
import Autosuggest from 'react-autosuggest';
import parse from 'autosuggest-highlight/parse/index';
import match from 'autosuggest-highlight/match/index';
import debounce from '../../SearchContent/debounce';
import HotelIcon from 'material-ui-icons/Hotel';
import { MenuItem } from 'material-ui/Menu/index';
import { fullSearch } from '../../../services/fullsearch';
import S from 'string';
import {
    DialogActions,
    DialogContent,
    Paper,
    Grid,
    Chip
} from 'material-ui';
import Button from 'material-ui/Button';
import Input, { InputLabel } from 'material-ui/Input';
import {
    FormControl,
    FormHelperText
} from 'material-ui/Form';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { translate } from 'react-i18next';
import i18n from '../../../services/i18n.js';
import clonedeep from 'lodash.clonedeep';
import {
    addSpecialDestination,
    updateSpecialDestination,
    getSpecialDestinationHotels
} from '../SpecialDestinationServices';

import { isEdge } from '../../../services/browserDetector';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: 'var(--primary-text-color)',
        backgroundColor: 'var(--primary-color)'
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    },
    // search box specific
    autosuggestContainer: {
        flexGrow: 1,
        position: 'relative',
        width: '100%',
        zIndex: 1000,
        fontWeight: 300,
    },
    autosuggestWrapper: {
        position: 'relative',
        width: '100%',
        paddingTop: '32px',
        float: 'left',
        marginRight: '2%',
        font: 'normal normal 300 normal 12px / 12px Roboto, Helvetica, Arial, sans-serif',
        color: '#3155A1',
    },
    autosuggestLabel: {
        position: 'absolute',
        top: 16,
        left: 0,
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 3,
        zIndex: 1500,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    chip: {
        margin: theme.spacing.unit
    }
});


function getSuggestionValue(suggestion) {
    return suggestion.formattedName;
}

function renderSectionTitle(section) {
    return (
        <div style={{ height: '40px', backgroundColor: 'lightgrey' }}>
            {getTitleIcon(section.title)}
            <strong
                style={{
                    float: 'left',
                    margin: '10px 0 0 5px',
                    top: '50%',
                    color: 'grey'
                }}>
                {i18n.t(section.title).toUpperCase()}
            </strong>
        </div>
    );
}

function getTitleIcon(sectionTitle) {
    const title = sectionTitle.toLowerCase();
    if (title === 'hoteles') {
        return <HotelIcon style={{
            float: 'left',
            padding: '5px 2px 0px 4px',
            color: 'var(--primary-color)'
        }} />;
    }
}

function getSectionSuggestions(section) {
    return section.data;
}

function shouldRenderSuggestions(value) {
    const MINIMUM_CHARS_TO_AUTOCOMPLETE = 3;
    return value && value.trim().length > MINIMUM_CHARS_TO_AUTOCOMPLETE;
}

function renderInput(inputProps) {
    const { classes, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            inputRef={ref}
            required={true}
            InputProps={{
                classes: {
                    input: classes.input,
                },
                ...other,
            }}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const titleCased = S(suggestion.formattedName.toLowerCase()).titleCase().s;
    const repeatedquery = query + ' ' + query + ' ' + query;
    const matches = match(titleCased, repeatedquery);
    const parts = parse(titleCased, matches);
    // const type = suggestion.type;
    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => {
                    return part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 600, color: '#444444' }}>
                            {part.text}
                        </span>
                    ) : (
                            <span key={String(index)} style={{ fontWeight: 300, color: '#757575' }}>
                                {part.text}
                            </span>
                        );
                })}
            </div>
        </MenuItem>
    );
}

function renderSuggestionsContainer(options) {
    const { containerProps, children } = options;
    return (
        <Paper {...containerProps} square>
            {children}
        </Paper>
    );
}


/**
 * 
 */
class SpecialDestinationAddDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            specialDestination: {
                id: '',
                name: '',
                hotels: [],
            },
            suggestions: [],
            selectedSuggestion: {},
            selectedHotels: [],
            value: '',
            isEditing: false,
            success: false,
            loading: false,
            failedName: true,
            inputError: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const blankSpecialDestination = {
            id: '',
            name: '',
        };

        const editSpecialDestination = clonedeep(nextProps.specialDestination);

        this.setState({
            specialDestination: editSpecialDestination ?
                editSpecialDestination : blankSpecialDestination,
            isEditing: editSpecialDestination ? true : false,
            success: false,
            loading: false,
            failedName: !editSpecialDestination,
            suggestions: [],
            selectedSuggestion: {},
            selectedHotels: [],
            value: '',
            inputError: false
        });

        this.fetchSelectedHotels(editSpecialDestination);
    }

    fetchSelectedHotels = async (specialDestination) => {
        if (specialDestination && specialDestination.hasOwnProperty('_id')) {
            let hotels = await getSpecialDestinationHotels(specialDestination);
            this.setState({ selectedHotels: hotels });
        }
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true });
        }

        if (!this.state.isEditing) {
            this.addSpecialDestination().then(result => {
                if (result.errorCode && result.errorCode !== 201) {
                    this.setState({
                        success: false,
                        loading: false
                    });

                    //TODO: REFACTOR WHEN IMPLEMENTS MULTILANGUAGE IN SCHEMA VALIDATION
                    let message = i18n.t('SPECIAL_DESTINATION.ADD_SPECIAL_DESTINATION_ERROR') + '\n' + i18n.t(result.message);
                    alert(message);
                }
                else {

                    this.setState({ success: true, loading: false });
                    this.props.onClose(true);
                }
            });
        }
        else {
            this.updateSpecialDestination().then(result => {
                if (!result.errorCode) {
                    this.setState({ success: true, loading: false });
                    this.props.onClose(true);
                }
                else {
                    this.setState({
                        success: false,
                        loading: false
                    });

                    //TODO: REFACTOR WHEN IMPLEMENTS MULTILANGUAGE IN SCHEMA VALIDATION
                    let message = i18n.t('SPECIAL_DESTINATION.UPDATE_SPECIAL_DESTINATION_ERROR') + '\n' + i18n.t(result.message);
                    alert(message);
                }
            });
        }
    };

    addSpecialDestination = async () => {
        try {
            this.state.specialDestination.hotels =
                this.state.selectedHotels.map(h => h.code);

            if (this.props.type) {
                this.state.specialDestination.accountName = this.props.type;
            }
            return await addSpecialDestination(this.state.specialDestination);
        } catch (error) {
            return error;
        }
    };

    updateSpecialDestination = async () => {
        try {
            this.state.specialDestination.hotels =
                this.state.selectedHotels.map(h => h.code);
            return await updateSpecialDestination(this.state.specialDestination);
        } catch (error) {
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    handleNameChange(data) {
        let specialDestinationAux = this.state.specialDestination;
        specialDestinationAux['name'] = data;
        this.setState({
            specialDestination: specialDestinationAux,
            failedName: (data.length === 0),
        });
    }

    handleHotelChange(data) {
        let specialDestinationAux = this.state.specialDestination;
        specialDestinationAux['hotels'] = data;
        this.setState({
            specialDestination: specialDestinationAux,
        });
    }

    disableAddButton = () => {
        const { failedName, failed, selectedHotels } = this.state;
        return failedName || failed || selectedHotels.length === 0;
    }

    loadSuggestions = async (value) => {
        const MAX_RESULTS = process.env.REACT_APP_FTS_MAX_RESULTS;
        let formattedSuggestions = await fullSearch(value, 'fullsearch/hotels');
        this.setState({
            suggestions: formattedSuggestions.slice(0, MAX_RESULTS),
        });
    };

    onChangeSearchBox = (event, { newValue }) => {
        this.setState({
            selectedSuggestion: null,
            value: newValue,
        });
    };

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

        let hotels = this.state.selectedHotels;
        let hotelsCodes = this.state.selectedHotels.map(h => h.code);

        if (!hotelsCodes.includes(suggestion.code)) {
            hotels.push(suggestion);
        }

        this.setState({
            selectedSuggestion: suggestion,
            selectedHotels: hotels,
            value: ''
        });
    };

    onSuggestionsFetchRequested = debounce(({ value }) => {
        this.loadSuggestions(value);
    }, parseInt(process.env.REACT_APP_FTS_DEBOUNCE));

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleDelete = hotel => () => {
        let hotels = this.state.selectedHotels;
        let newHotels = hotels.filter(h => h.code !== hotel.code);
        this.setState({ selectedHotels: newHotels });
    }

    renderSelectedHotels = () => {
        const hotels = this.state.selectedHotels;
        const { classes } = this.props;

        return hotels.map((hotel, index) => {
            return (
                <Chip
                    key={hotel.code}
                    label={hotel.name}
                    onDelete={this.handleDelete(hotel)}
                    className={classes.chip}

                />
            );
        });
    }

    render() {

        const { classes, title, t, ...other } = this.props;

        if (!this.state)
            return '';

        const {
            loading,
            isEditing,
            failedName,
            failed,
            message,
            suggestions,
            selectedSuggestion,
            value } = this.state;


        const inputProps = {
            classes,
            placeholder: t('SPECIAL_DESTINATION.HOTEL_NAME'),
            value,
            onChange: this.onChangeSearchBox,
            selectedsuggestion: selectedSuggestion,
            disabled: this.state.loading,
            error: this.state.inputError,
            endAdornment: <HotelIcon className={classes.keyboardIcon} />,
        };
        const theme = {
            container: classes.autosuggestContainer,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
        };

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="special-destination-dialog"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle
                    id="special-destination-dialog"
                    disableTypography={true}
                    className={classes.dialogTitle}
                >
                    {isEditing ?
                        t('SPECIAL_DESTINATION.EDIT_SPECIAL_DESTINATION_TITLE') :
                        t('SPECIAL_DESTINATION.ADD_SPECIAL_DESTINATION_TITLE')
                    }
                </DialogTitle>
                <DialogContent className="cmsDialogAddDestination">
                    <Paper elevation={0}>
                        <FormControl fullWidth error={failedName}>
                            <InputLabel
                                htmlFor="specialDestinationName"
                                className={classes.inputLabel}
                                shrink={true}
                            >
                                {t('SPECIAL_DESTINATION.SPECIAL_DESTINATION_NAME')} *
                            </InputLabel>
                            <Input
                                id="specialDestinationName"
                                value={this.state.specialDestination.name}
                                placeholder={t('SPECIAL_DESTINATION.SPECIAL_DESTINATION_NAME')}
                                autoFocus={true}
                                onChange={event => {
                                    this.handleNameChange(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <span></span>
                        <Grid
                            container
                            direction='column'
                            alignItems={'baseline'}
                            style={{ marginTop: '10px' }}
                        >
                            <Grid
                                item
                                xs={12}
                                style={{ width: '100%', height: '80px' }}
                            >
                                <div className={classes.autosuggestWrapper}>
                                    <label className={classes.autosuggestLabel}>
                                        {' '}
                                        {t('SPECIAL_DESTINATION.HOTEL_NAME')}{' '}
                                    </label>
                                    <Autosuggest
                                        theme={theme}
                                        multiSection={true}
                                        suggestions={suggestions}
                                        renderInputComponent={renderInput}
                                        shouldRenderSuggestions={shouldRenderSuggestions}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        onSuggestionSelected={this.onSuggestionSelected}
                                        renderSuggestionsContainer={renderSuggestionsContainer}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSectionTitle={renderSectionTitle}
                                        getSectionSuggestions={getSectionSuggestions}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={inputProps}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}
                                style={{
                                    height: '80px',
                                    marginTop: isEdge() ? '80px' : 0
                                }}>
                                {this.renderSelectedHotels()}
                            </Grid>
                        </Grid>

                        <span></span>
                        {failed ? (
                            <FormHelperText>{t(message)}</FormHelperText>
                        ) : (
                                ''
                            )}
                    </Paper>

                </DialogContent>

                <DialogActions className={classes.root + ' cmsDialogActions'} style={{ padding: '12px' }}>

                    <div className={classes.wrapper}>
                        <Button
                            disabled={loading}
                            onClick={this.handleCancel}
                        >
                            {t('SPECIAL_DESTINATION.CANCEL_BUTTON')}
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={loading || this.disableAddButton()}
                            onClick={this.handleClose}>
                            {isEditing ?
                                t('SPECIAL_DESTINATION.SAVE_BUTTON') :
                                t('SPECIAL_DESTINATION.ACCEPT_BUTTON')
                            }
                            {
                                loading &&
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            }
                        </Button>
                    </div>

                </DialogActions>
            </Dialog>
        );
    }
}

SpecialDestinationAddDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(SpecialDestinationAddDialog));



// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Dialogs/SpecialDestinationAddDialog.js